/**
 * Translations have been synchronous by default on TPP. We must come with a way to make
 * them async, but, until then, please work with translations in a unified way, so they are
 * simpler to migrate to async translations in the future.
 * Please, use this file to generalize the way translations are used in the app.
 *
 * Please take a look at local-dev/samples/translationsAsync.js.sample
 * to check out a general idea of a possible async translation implementation.
 *
 * The main idea is to have a single source of truth for translations. One day we might be able to change
 * const {t, messages} = syncTranslationElements(intl);
 * to
 * const {t, messages} = await asyncTranslationElements(intl);
 *
 * And the app should work as expected.
 */

import messages from '../translationMessages';
import { formatMessage } from '../language';

// TODO: we could deal with intl and rest of functions on language.js here, somehow...
export const syncTranslationElements = (intl) => {
  const t = intl?.formatMessage || formatMessage;
  return { t, messages, formatMessage };
};
